import { Component, EventEmitter, Input, Output } from '@angular/core';

export type DynamicPageHoverEffect = 'none' | 'darken' | 'lighten';

@Component({
  selector: 'lib-dynamic-page-element-hover',
  standalone: false,
  templateUrl: './dynamic-page-element-hover.component.html',
  styleUrl: './dynamic-page-element-hover.component.scss'
})
export class DynamicPageElementHoverComponent {
  @Input() showEffect = false;
  @Input() showColors = false;

  @Input() effect: DynamicPageHoverEffect;
  @Input() background: string;
  @Input() color: string;

  @Output() effectChange = new EventEmitter<DynamicPageHoverEffect>();
  @Output() backgroundChange = new EventEmitter<string>();
  @Output() colorChange = new EventEmitter<string>();

  effects: { id: DynamicPageHoverEffect; label: string }[] = [
    { id: 'none', label: 'None' },
    { id: 'darken', label: 'Darken' },
    { id: 'lighten', label: 'Lighten' }
  ];

  setEffect(effect: DynamicPageHoverEffect) {
    this.effect = effect;
    this.effectChange.emit(effect);
  }

  setBackground(value: string) {
    this.background = value || null;
    this.backgroundChange.emit(this.background);
  }

  setColor(value: string) {
    this.color = value || null;
    this.colorChange.emit(this.color);
  }
}
